import React, {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";

import StyledTableContainer from "components/Table/StyledTableContainer";

import TableHeader from "./components/TableHeader";
import TableRowItem from "./components/TableRowItem";
import EnrichmentActions, {tabIds} from "../EnrichmentActions";

import {getToBeEnriched} from "api/product/enrichment";
import Loader from "./components/Loader";
import {fields, getFieldToEnrich} from "./helpers/product";


function EnrichmentTable({ productsToBeEnriched: propsProducts, loading: propsLoading }) {
    const { id: retailerId } = useParams();

    const [selected, setSelected] = useState([]);
    const [activeId, setActiveId] = useState(tabIds.TOUS);
    const [loading, setLoading] = useState(propsLoading ?? true);
    const [productsToBeEnriched, setProductsToBeEnriched] = useState(propsProducts ?? []);

    useEffect(() => {
        if (propsProducts !== undefined) {
            setProductsToBeEnriched(propsProducts);
        }
    }, [propsProducts]);

    useEffect(() => {
        if (propsLoading !== undefined) {
            setLoading(propsLoading);
        }
    }, [propsLoading]);

    useEffect(() => {
        if (retailerId && propsProducts === undefined) {
            setLoading(true);
            getToBeEnriched(retailerId, 1, 50)
                .then((response) => {
                    setProductsToBeEnriched(response["hydra:member"] || []);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [retailerId]);

    const handleSetActiveId = (id) => {
        setActiveId(id);
        setSelected([]);
    };

    const handleCheck = (id) => {
        setSelected((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    const filteredProducts = productsToBeEnriched.filter(product => {
        if (activeId === tabIds.TOUS) return true;
        if (activeId === tabIds.DESCRIPTION) return getFieldToEnrich(product) === fields.DESCRIPTION;
        if (activeId === tabIds.IMAGE) return [fields.PICTURE, fields.PICTURES].includes(getFieldToEnrich(product));
        if (activeId === tabIds.METATITLE) return product.attribute === "meta title";
        if (activeId === tabIds.METADESC) return product.attribute === "meta desc";

        return product.attribute === activeId;
    });

    const allChecked = selected.length === filteredProducts.length && filteredProducts.length > 0;

    const handleCheckAll = () => {
        setSelected(allChecked ? [] : filteredProducts.map((r) => r.id));
    };

    if (loading) {
        return <Loader loading={loading}/>
    }

    return (
        <div>
            <EnrichmentActions
                selected={selected}
                list={() => {}}
                match={{}}
                activeId={activeId}
                setActiveId={handleSetActiveId}
                productsToBeEnriched={productsToBeEnriched}
            />
            <StyledTableContainer>
                <Table>
                    <TableHeader allChecked={allChecked} onCheckAll={handleCheckAll}/>
                    <TableBody>
                        {filteredProducts.map((row) => (
                            <TableRowItem
                                key={row.id}
                                product={row}
                                checked={selected.includes(row.id)}
                                onCheck={() => handleCheck(row.id)}
                            />
                        ))}
                    </TableBody>
                </Table>
            </StyledTableContainer>
        </div>

    );
}

export default EnrichmentTable;
